module.exports = __webpack_public_path__ + "img/card.e4de227e.svg";